export default {
    initEnvironment: () => {
        return {
            url: '/ticketsgit/initialize',
            method: 'GET'
        };
    }
};



// WEBPACK FOOTER //
// ./environments/ticketsgit/api.js